import { useMutation } from '@tanstack/react-query'

import { getReactHubToken } from '../api'

const useSetupIntegrationConnection = () => {
  return useMutation(getReactHubToken)
}

export default useSetupIntegrationConnection
